<template>
  <div class="profile">
    <!-- 头部 -->
    <div class="profile-header">
      <div class="profile-header-content">
        个人中心
      </div>
    </div>
    <!-- 头部END -->

    <!-- 主要内容 -->
    <div id="main">
      <div class="main-left" style="font-size: 16px; color: #606266;">
        <div style="display: flex;align-items: center; margin-right: 10px">
          <img :src="this.$store.getters.getUser.avatar? this.$store.getters.getUser.avatar:handeImg"
               style="width: 2.925rem;height: 2.925rem;border-radius: 50%;margin-right: 0.625rem;"/>
          <div>
            <div>{{ this.$store.getters.getUser.nickname }}</div>
            <div>ID:{{ this.$store.getters.getUser.userNo }}</div>
          </div>
        </div>
        <div
            style="margin-top: 0.625rem;border-top: 0.0625rem solid #F0F0F0;line-height: 1.875rem;padding-top: 0.625rem;cursor: pointer;">
          <div ref="profileSet" style="padding-left: 7px; display: flex;align-items: center;"
               @click="componentFun('profile')/* = 'profile'*/">
            <img src="../assets/imgs/user.png"
                 style="width: 0.925rem;height: 0.925rem;margin-right: 0.925rem;"/>个人信息
          </div>

          <div ref="orderSet" style="padding-left: 7px;display: flex;align-items: center;background-color: #F0F0F0FF;"
               @click="componentFun('order')/* = 'order'*/">
            <img src="../assets/imgs/order.png"
                 style="width: 0.925rem;height: 0.925rem;margin-right: 0.925rem;"/>订单信息
          </div>
          <div ref="passwordSet" style="padding-left: 7px;display: flex;align-items: center;"
               @click="componentFun('password')/* = 'order'*/">
            <img src="../assets/imgs/password.png"
                 style="width: 0.925rem;height: 0.925rem;margin-right: 0.925rem;"/>修改密码
          </div>
        </div>
      </div>
      <div class="main-right">
        <MyOrder v-if="componentName == 'order'"/>
        <MyProfile v-if="componentName == 'profile'"/>
        <MyPasswordSet v-if="componentName == 'password'"/>
      </div>
    </div>


    <!-- 主要内容END -->
  </div>
</template>
<script>
import order from "@/views/Order.vue";
import MyPasswordSet from "@/components/MyPasswordSet.vue";

export default {
  components: {MyPasswordSet},
  computed: {
    order() {
      return order
    }
  },
  data() {
    return {
      componentName: 'order',  // 默认为订单页面
      handeImg: require('../assets/imgs/head-sculpture.png'),
    };
  },
  methods: {
    componentFun(test) {
      if (test === "order") {
        this.$refs.orderSet.style.backgroundColor = "#F0F0F0FF"
        this.$refs.profileSet.style.backgroundColor = ""
        this.$refs.passwordSet.style.backgroundColor = ""
      } else if (test === "profile") {
        this.$refs.orderSet.style.backgroundColor = ""
        this.$refs.profileSet.style.backgroundColor = "#F0F0F0FF"
        this.$refs.passwordSet.style.backgroundColor = ""
      } else if (test === "password") {
        this.$refs.orderSet.style.backgroundColor = ""
        this.$refs.profileSet.style.backgroundColor = ""
        this.$refs.passwordSet.style.backgroundColor = "#F0F0F0FF"
      }

      this.componentName = test
    }
  }
};
</script>
<style scoped>
.profile {
  background-color: #f5f5f5;
  padding-bottom: 20px;
}

/* 我的订单头部CSS */
.profile .profile-header {
  height: 9.375rem;
  background-image: url("../assets/imgs/bg-user.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-bottom: 20px;
}

.profile .profile-header .profile-header-content {
  width: 1225px;
  margin: 0 auto;
  text-align: center;
  color: #FFFFFF;
  font-weight: bold;
  font-size: 2rem;
  line-height: 9rem;
}

#main {
  background: #F4F4F4;
  padding: 0 6.375rem;
  display: flex;
}

#main .main-left {
  min-width: 10%;
  background: #FFFFFF;
  border-radius: 0.625rem;
  padding: 1.25rem;
  box-shadow: 2px 2px 2px #F4F4F4;
}

#main .main-right {
  margin-left: 0.3125rem;
  width: 90%;
  background: #FFFFFF;
  border-radius: 0.625rem;
  padding: 0.8375rem;
  box-shadow: 2px 2px 2px #F4F4F4;
}
</style>